import EsimsPage from './views/EsimsPage.vue';
import EsimProductPage from './views/EsimProductPage.vue';

export default [
  {
    path: '/esim',
    name: 'esim-browse',
    component: EsimsPage,
    meta: {
      title: 'eSim - Voyagez connecté',
      headerColor: '#01F37A'
    }
  },
  {
    path: '/esim/:slug',
    name: 'esim-product',
    component: EsimProductPage,
    meta: {
      title: 'eSIM - Forfait'
    }
  }
];
